<template>
	<h2 v-if="!noFollow" class="font-bold text-2xl ">
		{{ trans('global.pages.login') }}
	</h2>
	<p v-if="noFollow" class="text-sm mb-2 small">
		<span v-if="globalStateStore.showReLoginModal">
			{{ trans('global.phrases.reauth_desc') }}
		</span>
		<span v-else-if="props.showLogoutSessions">
			{{ trans('global.phrases.logout_other_sessions_desc') }}
		</span>
	</p>
	<LoginForm :no-follow="noFollow" :show-logout-sessions="showLogoutSessions" :element-id="elementId" @submit="submit()" @close="close()"/>
	<div v-if="!noFollow">
		<div class=" text-sm border-b py-4">
			<router-link to="/forgot-password" class="text-sm base-link">
				{{ trans('global.phrases.forgot_password_ask') }}
			</router-link>
		</div>
		<hr>
		<div class="mt-3 text-sm py-4">
			<p>{{ trans('global.phrases.register_ask') }}</p>
			<div class="text-center">
				<router-link to="/register">
					<UiButton :label="trans('global.buttons.register')"/>
				</router-link>
			</div>
		</div>
	</div>
</template>

<script lang="ts" setup>
	import UiButton from "@/views/components/input/UiButton.vue";

	import { default as LoginForm } from "@/views/pages/auth/login/LoginForm.vue";
	import { useGlobalStateStore } from "@/stores/global";

	import { trans } from "@/helpers/i18n";
	// import Auth from "@/views/layouts/Auth.vue";
	import { onMounted } from "vue";

	const globalStateStore = useGlobalStateStore();

	const emit = defineEmits(["submit", "clear", "close"]);
	function close () {
		clear();
		emit("close");
	}
	function clear () {
		emit("clear");
	}
	function submit () {
		emit("submit");
	}
	const props = withDefaults(defineProps<{
		noFollow?: boolean,
		showLogoutSessions?: boolean,
		elementId?: string
	}>(), {
		noFollow: false,
		showLogoutSessions: false,
		elementId: "login"
	});

</script>
